/**
 * StrictModeDroppable - Workaround for react-beautiful-dnd with React 18 StrictMode
 *
 * React 18's StrictMode double-renders components, which breaks react-beautiful-dnd.
 * This wrapper delays the Droppable mount to avoid the issue.
 *
 * @see https://github.com/atlassian/react-beautiful-dnd/issues/2399
 */

import React, { useState, useEffect } from 'react';
import { Droppable, DroppableProps } from 'react-beautiful-dnd';

const StrictModeDroppable: React.FC<DroppableProps> = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    // Use requestAnimationFrame to delay enabling the droppable
    // This allows the first StrictMode render to complete before enabling
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
};

export default StrictModeDroppable;
